'use client';

import { Image } from '@ahafood/ui/components/image';
import React from 'react';

/**
 * Decorative voucher icons trên nền Flash Deal.
 * Static positions — không animate để giảm render cost
 * (trước đó animate fall infinite gây nặng GPU/main thread).
 */
const icons = [
  { size: 80, top: '-3%', left: '1vw', rotation: -20, opacity: 0.55 },
  // { size: 100, top: '20%', left: '25vw', rotation: 30, opacity: 0.45 },
  // { size: 60, top: '55%', left: '40vw', rotation: -10, opacity: 0.5 },
  { size: 130, top: '0%', left: '70vw', rotation: 25, opacity: 0.4 },
  // { size: 50, top: '65%', left: '80vw', rotation: -35, opacity: 0.55 },
  // { size: 90, top: '40%', left: '90vw', rotation: 15, opacity: 0.45 },
  { size: 85, top: '85%', left: '5vw', rotation: -25, opacity: 0.5 },
];

const PromoIcons = () => {
  return (
    <div
      aria-hidden
      className="absolute inset-0 pointer-events-none overflow-hidden z-[1]"
    >
      {icons.map((cfg, index) => (
        <div
          key={index}
          className="absolute"
          style={{
            top: cfg.top,
            left: cfg.left,
            width: cfg.size,
            height: cfg.size,
            transform: `rotate(${cfg.rotation}deg)`,
            opacity: cfg.opacity,
          }}
        >
          <Image
            src="/static/images/promo.webp"
            alt=""
            width={cfg.size}
            height={cfg.size}
            className="object-contain"
          />
        </div>
      ))}
    </div>
  );
};

export default PromoIcons;
